import { ENTRYPOINTS } from '../constants';

const isLoginEntrypoint = (entrypoint) =>
  entrypoint === ENTRYPOINTS.IDENTITY_LOGIN ||
  entrypoint === ENTRYPOINTS.IDENTITY_LOGIN_CALLBACK;

const isConsentEntrypoint = (entrypoint) =>
  entrypoint === ENTRYPOINTS.SUBSCRIPTION_SUBSCRIBE ||
  entrypoint === ENTRYPOINTS.SUBSCRIPTION_UNSUBSCRIBE ||
  entrypoint === ENTRYPOINTS.SUBSCRIPTION_FAILED;

export { isLoginEntrypoint, isConsentEntrypoint };
